import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import translationEN from "./locales/english.json";
import translationTR from "./locales/turkish.json";

const resources = {
  en: {
    translation: translationEN,
  },
  tr: {
    translation: translationTR,
  },
};

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    lng:
      localStorage.getItem("i18nextLng") !== undefined && localStorage.getItem("i18nextLng") !== null 
        ? localStorage.getItem("i18nextLng").split("-")[0]
        : "tr",
    fallbackLng: ["en", "tr"],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
